import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Pausar novos pedidos',
  sections: {
    pause_orders: {
      title: 'Durante quanto tempo estará indisponível?',
      description: 'Informaremos os clientes que não está a aceitar novos pedidos',
    },
    order_methods: {
      title: 'Os meus métodos de pedido',
      description: 'Ative ou desative os métodos de pedido dos seus clientes',
    },
    delivery_mode: {
      title: 'Métodos de entrega',
      description: 'Alterne entre a sua rede de estafetas e a nossa',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 hora',
        '2_hours': '2 horas',
        rest_of_day: 'Resto do dia',
      },
    },
    has_standalone_delivery: {
      label: 'Os meus estafetas',
    },
    has_external_delivery: {
      label: 'Rede de estafetas {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Entregas desativadas',
    delivery_orders_on: 'Entregas ativadas',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Tem a certeza que pretende ativar as entregas?',
        description: '',
      },
      [false]: {
        title: 'Tem a certeza que pretende desativar as entregas?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Tem a certeza que pretende mudar para os seus estafetas?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Tem a certeza que pretende mudar para os estafetas {{provider}}?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas com sucesso',
  },
};
